<script>
  export let id;
  export let label;
  export let value = '';
  export let options = [];
  export let disabled = false;
  export let loading = false;
  export let placeholder = 'Seleccionar';
  export let openOnFocus = false;
  export let onInput = () => {};
  export let onSelect = () => {};
  let open = false; let all = false; let active = 0; let input; let root;
  const normalize = text => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  $: matches = options.filter(option => all || !value || normalize(option.name + ' ' + option.id).includes(normalize(value))).slice(0, 50);
  $: if (active >= matches.length) active = Math.max(0, matches.length - 1);
  function choose(option) { value = option.name; open = false; all = false; onSelect(option); input?.focus(); }
  function type(event) { value = event.currentTarget.value; open = true; all = false; active = 0; onInput(value); }
  function toggle() { open = !open; all = true; active = 0; input?.focus(); }
  function keyboard(event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!open) { active = event.key === 'ArrowDown' ? 0 : Math.max(0, matches.length - 1); open = true; }
      else { const step = event.key === 'ArrowDown' ? 1 : -1; active = Math.max(0, Math.min(matches.length - 1, active + step)); }
    } else if (event.key === 'Enter' && open && matches.length) { event.preventDefault(); choose(matches[active]); }
    else if (event.key === 'Escape' && open) { event.preventDefault(); event.stopPropagation(); open = false; }
  }
  function blur(event) { if (!root?.contains(event.relatedTarget)) open = false; }
</script>
<div class="search-combo" bind:this={root}>
  <label for={id}>{label}</label><div class="search-combo-input">
    <input bind:this={input} {id} type="search" role="combobox" aria-autocomplete="list" aria-expanded={open} aria-controls={id + '-options'} aria-activedescendant={open && matches[active] ? `${id}-option-${active}` : undefined} autocomplete="off" bind:value {placeholder} disabled={disabled || loading} on:input={type} on:focus={() => { if (openOnFocus && !disabled && !loading) { open = true; all = false; } }} on:keydown={keyboard} on:blur={blur} />
    <button type="button" disabled={disabled || loading} aria-label={'Mostrar opciones de ' + label} aria-expanded={open} aria-controls={id + '-options'} on:mousedown|preventDefault on:click={toggle}>▾</button>
  </div>
  {#if loading}<small class="muted">Cargando opciones…</small>{/if}
  {#if open && !disabled}<div class="search-combo-options" role="listbox" id={id + '-options'} aria-label={'Opciones de ' + label}>
    {#each matches as option, index}<button type="button" role="option" id={`${id}-option-${index}`} aria-selected={index === active} tabindex="-1" class:active={index === active} on:mousedown|preventDefault on:click={() => choose(option)}><strong>{option.name}</strong><small>{option.id}</small></button>{:else}<p>No se encontraron opciones.</p>{/each}
  </div>{/if}
</div>
